export default __webpack_public_path__ + "static/media/204.ac8674a1.png";